import React from 'react'
import { Switch, Route, Redirect } from 'react-router'
// import { getCancelToken } from '@/utils/request'
// import { global, changeGlobal } from '../utils/global'

function renderRoutes (routes, auth, extraProps = {}, switchProps = {}) {

  return routes ? (
    <Switch {...switchProps}>
      {routes.map((route, i) => (
        <Route
          key={route.key || i}
          path={route.path}
          exact={route.exact}
          strict={route.strict}
          render={props => {
            document.title = route.title || '博鳌医学'
            if (route.auths && !route.auths.includes(auth)) {
              // 进行拦截
              console.log('route', route.auths)
            }
            // if (global.source.token && global.source.cancel) global.source.cancel('取消请求')
            // changeGlobal('source', getCancelToken())
            // changeGlobal('timestamp', new Date().getTime())

            return route.render ? (
              route.render({ ...props, ...extraProps, route: route })
            ) : (
              <route.component {...props} {...extraProps} route={route} />
            )
          }
          }
        />
      ))}
      <Redirect to="/login" />
    </Switch>
  ) : null
}

export default renderRoutes
